import { useAuth } from "@/auth/AuthProvider";
import { SignalRequestDialog } from "@/components/submissions/SignalRequestDialog";
import {
  MANUAL_NOTE_MAX,
  manualQuoteLine,
  manualRefusalOf,
  requestManualQuote,
} from "@/lib/submissions/manualQuotes";

/**
 * "Request a quote" from a carrier Signal quotes by hand (BRK-S395,
 * PMS-S819): its own dialog (`SignalRequestDialog`), from the carrier's
 * popup. Sending opens a `quote_request` action: Signal keys the application
 * into the carrier's website and enters the quote, which then shows on the
 * carrier's card (PMS-S820).
 */
export function RequestManualQuoteDialog({
  submissionId,
  carrierId,
  carrier,
  open,
  onClose,
  onChanged,
}: {
  submissionId: string;
  carrierId: string;
  carrier: string;
  open: boolean;
  onClose: () => void;
  onChanged: () => void | Promise<void>;
}) {
  const { authedRequest } = useAuth();
  return (
    <SignalRequestDialog
      open={open}
      onClose={onClose}
      title="Request a quote"
      intro={`${carrier} quotes on its own website, so Signal keys in the application and adds ${carrier}’s quote here.`}
      noteMax={MANUAL_NOTE_MAX}
      noteHelp="Anything Signal should know for this carrier, such as the effective date it needs."
      send={(idempotencyKey, note) =>
        requestManualQuote(authedRequest, submissionId, carrierId, {
          idempotencyKey,
          note,
        })
      }
      refusalOf={manualRefusalOf}
      answered={(standing) => ({
        chip: "Requested",
        line: manualQuoteLine(carrier, standing),
      })}
      onChanged={onChanged}
    />
  );
}
